import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import classNames from 'classnames';
import Icon from 'ziphy-web-shared/basic/assets/images/Icon';
import styles from './FloatingBar.module.scss';
const FloatingBar = forwardRef(({ label, onClose, className, children, leftOffset = 0, bottomOffset = 0 }, ref) => {
    return (_jsxs("div", Object.assign({ id: "floating-bar", ref: ref, className: classNames(styles.wrapper, className), style: {
            '--selection-bar-left-offset': `${leftOffset}px`,
            '--selection-bar-bottom-offset': `${bottomOffset}px`,
        } }, { children: [label && _jsx("div", Object.assign({ className: styles.label }, { children: label })), _jsx("div", Object.assign({ className: styles.content }, { children: children })), onClose && (_jsx("div", Object.assign({ className: styles.closeButton, onClick: onClose }, { children: _jsx(Icon, { type: 'close' }) })))] })));
});
export default FloatingBar;
